import { z } from "zod";
/**
 * The languages the APP ships (`D42`), region included on both.
 *
 * Declared once and imported, rather than written as a literal wherever a
 * locale crosses the wire. There are already two consumers — the sign-in email
 * (`requestOtpInput`) and the trainer's answer (`wsTicketIdentity`) — and a
 * second copy of this list is a set that can be extended in one place and not
 * the other, which parses clean on one route and rejects on the next.
 *
 * Deliberately NOT `catalogueLocale`. That one is `en` / `pt` — the languages
 * the CATALOGUE is loaded in (`D26`) — and the two sets are mapped onto each
 * other in `apps/mobile/src/lib/catalog/catalog-locale.ts` precisely because
 * they are different sets that happen to look similar.
 *
 * It sits at the contract ROOT rather than under `iam/`, beside `error.ts` and
 * for the same reason: the language a person reads is not an identity concept.
 * It happens to have two identity-shaped consumers today — the sign-in email
 * and the WebSocket ticket — and filing it under `iam/` would make the next
 * consumer look like it was reaching into another concern.
 *
 * Seven since `D267`: the five after the first two are translated locales,
 * whose missing messages fall back (`pt-PT` to `pt-BR`, the rest to `en-US`).
 *
 * `en-US` is the base and the fallback for everything (`SUPPORTED_LOCALES` in
 * `packages/shared/client/src/i18n/locale.ts` is the client-side twin, and cannot
 * import this because the app must not depend on a Worker's contract for its
 * own startup path).
 */
export const appLocale = z.enum([
    "en-US",
    "pt-BR",
    "es-419",
    "pt-PT",
    "fr-FR",
    "de-DE",
    "it-IT",
]);
//# sourceMappingURL=locale.js.map